import { ReactElement } from "react";
import ConfirmEmailCodeView from "views/confirm-email-code";

const ConfirmEmailCode = (): ReactElement => {
  return <ConfirmEmailCodeView />;
};

export default ConfirmEmailCode;
